import {BooleanHelper} from '~/helpers/booleanHelper'
import {IDynamicFieldsDestinationOptions, IProcessFlowCommonHandlerConfig} from '~/interfaces/dynamicFieldsElementOptionsInterfaces'

export function assignProcessFlowDynamicFieldsCommonOptions(handler: IProcessFlowCommonHandlerConfig, options: IProcessFlowCommonHandlerConfig): void {
  assignDynamicFieldsDestinationOptions(handler, options)
  if (options.variable) handler.variable = options.variable
  if (BooleanHelper.isStrictBoolean(options.restrictToTopLevelCollections)) handler.restrictToTopLevelCollections = options.restrictToTopLevelCollections
  if (BooleanHelper.isStrictBoolean(options.restrictToRootModel)) handler.restrictToRootModel = options.restrictToRootModel
  if (options.allowedGenericTypes) handler.allowedGenericTypes = options.allowedGenericTypes;
}

export function assignDynamicFieldsDestinationOptions(item: IDynamicFieldsDestinationOptions, options: IDynamicFieldsDestinationOptions): void {
  if (BooleanHelper.isStrictBoolean(options.destinationIsCollection)) item.destinationIsCollection = options.destinationIsCollection
  if (options.destinationValue) item.destinationValue = options.destinationValue;
}